import React from 'react';
import {useCustomStore} from './DepositorSectionStore';
import DepositorSectionView from './DepositorSectionView';

function DepositorSectionContainer() {
  const {dispatch} = useCustomStore();

  React.useEffect(() => {
    dispatch({type: 'FETCH_DOCUMENTS'});
  }, []);

  return (
    <DepositorSectionView/>
  );
}

export default DepositorSectionContainer;
